import { ReviewCycleEmployeeMetrics } from 'Shared/utils/hooks/use-review-cycle-employee-metrics-fetch';
import { PiEmployeeType } from 'Shared/types/PiEmployee.type';
import instance from './instance';

export type fetchPiEmployeeResponse = { id: string; type: 'piEmployee'; attributes: PiEmployeeType };

export type fetchEmployeeMetricsResponse = {
  data: {
    id: string; // org_slug
    type: 'piEmployeeMetrics';
    attributes: ReviewCycleEmployeeMetrics;
  };
  included?: Array<fetchPiEmployeeResponse>;
};

export const fetchEmployeeMetrics = () => instance.get<fetchEmployeeMetricsResponse>(`/pi_employees/metrics`);

export const fetchEmployees = () => instance.get(`/pi_employees/emails`);
